<template>
  <div class="field-info">
    <span class="field-info-value">{{ value }}</span>
    <span class="field-info-label" v-if="label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "FieldInfo",

  props: ["value", "label"], 
};
</script>

<style lang="scss" scoped>
.field-info {
  &-value {
    color: #2c3153;
    font-size: 18px;
    font-weight: 400;
    display: block;
  }

  &-label {
    font-size: 12px;
    line-height: 13px;
    color: #9e9e9e;
    display: block;
    margin-top: 4px;
  }
}
</style>
